{
  "de": {
    "partners": {
      "headings": {
        "course": "Jetzt weiterbilden mit {partner}",
        "description": "Darum empfehlen wir {partner}:",
        "emptyState": "Leider wurden keine Partnereinträge gefunden.",
        "feedback": "Fehlt dein Lieblingstool oder möchtest du eine Anwendung empfehlen?",
        "materials": "Entdecke Materialien von {partner}",
        "subtitle": "Was möchtest du heute nutzen?",
        "title": "Lerne ausgewählte Bildungspartner kennen"
      },
      "hints": {
        "notPublished": "Dieser Partner ist noch nicht veröffentlicht. Nur sichtbar für Admins. 😎"
      },
      "links": {
        "breadCrumbIndex": "Partnerübersicht",
        "login": "Einloggen",
        "loginWithFobizz": "Jetzt einloggen mit fobizz",
        "registerWithFobizz": "Jetzt ausprobieren mit fobizz",
        "sendFeedback": "Schreib uns gerne eine E-Mail an"
      }
    }
  }
}
